import StandingsTestingBase from "./StandingsTestingBase";

export default function StandingsTestingPro() {
    return (
        <StandingsTestingBase
            scopeType="DRIVER"
            classKey="PRO"
            heading="Meisterschaftswertung"
            pillLabel="PRO"
        />
    );
}
